// src/section.tsx
import * as React from "react";
import { jsx } from "react/jsx-runtime";
var Section = React.forwardRef(
  ({ children, style, ...props }, forwardedRef) => {
    return /* @__PURE__ */ jsx(
      "table",
      {
        align: "center",
        width: "100%",
        ...props,
        ref: forwardedRef,
        "data-id": "react-email-section",
        style,
        border: 0,
        cellPadding: "0",
        cellSpacing: "0",
        role: "presentation",
        children: /* @__PURE__ */ jsx("tbody", { children: /* @__PURE__ */ jsx("tr", { children: /* @__PURE__ */ jsx("td", { children }) }) })
      }
    );
  }
);
Section.displayName = "Section";
export {
  Section
};
